import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MdwAvatar } from '@spaces-ui/meadow/components/avatar';
import { ExternalConnection_Fill } from '@spaces-ui/meadow/icons/svgs';

import { Sample } from '../../components';

@Component({
  selector: 'app-avatars',
  imports: [Sample, MdwAvatar, MatTooltipModule],
  templateUrl: './avatars.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './avatars.scss',
})
export class Avatars {
  public icons = { ExternalConnection_Fill };
}
